import styled from 'styled-components';

export const MainScreen = styled.div`
  background:
    linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    #000 url('img/background.png') no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  min-height: calc(100svh - 88px);

  @media screen and (max-width: 960px) {
    min-height: calc(100svh - 64px);
  }
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const HomeLayer = styled.div`
  width: 100%;
  height: 100%;
`;

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: clamp(96px, 10vw, 140px) clamp(20px, 7vw, 100px) clamp(36px, 6vw, 80px);
  display: flex;
  justify-content: center;

  align-items: center;
  position: relative;

  gap: clamp(24px, 5vw, 72px);

  @media screen and (max-width: 900px) {
    padding: 96px 20px 36px;
    flex-direction: column;
  }
`;

export const MainText = styled.div`
  width: min(50%, 620px);
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;

  flex-direction: column;

  @media screen and (max-width: 900px) {
    width: min(100%, 680px);
    height: auto;
  }
`;

export const MainLogo = styled.div`
  width: min(50%, 620px);
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 900px) {
    width: min(100%, 620px);
    height: auto;
  }
`;

export const LogoImage = styled.img`
  width: 90%;
  -webkit-filter: drop-shadow(3px 5px 50px #000);
  filter: drop-shadow(3px 5px 50px #000);
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const Midle = styled.div`
  display: flex;
  margin: 20px 0;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const MidleLogo = styled.img`
  width: 70%;
  height: auto;
  margin: 10px;
  /* filter: drop-shadow(2px 2px 5px #eee); */
`;
export const MidleText = styled.img`
  width: 230px;
  height: auto;
  filter: drop-shadow(2px 2px 5px #eee);
`;

export const HeadText = styled.span`
  font-size: clamp(1.75rem, 4vw, 2.4rem);
  text-align: center;
  font-weight: 700;
  color: #e0e0e0;
`;
